import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onUnmounted, ref, watch } from "vue";
import BaseList from "@/components-UI/list/BaseList.vue";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import SvgArrow from "@/assets/icons/arrow-down.svg";
import {
    formatConversionHistoryAmount,
    formatConversionHistoryScalar,
    isConversionHistoryMonetaryEvent,
    isExpandableHistoryValue,
    getConversionHistoryPopupRows,
} from "@/utils/conversionHistory";

interface Props {
    value: unknown;
    title?: string;
    /** `IConversionEvent.type` — для оформления сумм в колонках */
    eventType?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionChangeHistoryItem',
  props: {
    value: null,
    title: { default: '' },
    eventType: { default: '' }
  },
  setup(__props: any) {

const props = __props as { value: unknown, title: string, eventType: string }



const isShowMenu = ref(false);

const $vuetify = (getCurrentInstance()!.proxy as any).$vuetify;

const isMobile = computed(() => $vuetify.breakpoint.width <= 769);

const menuWidth = computed(() => (isMobile.value ? '100vw' : '480px'));

const menuHeight = computed(() => (isMobile.value ? '100vh' : '550px'));

const detailRows = computed(() => getConversionHistoryPopupRows(props.value));

const isExpandable = computed(() => isExpandableHistoryValue(props.value));

const isAmountCellLayout = computed(
    () => isConversionHistoryMonetaryEvent(props.eventType) && !isExpandable.value,
);

const plainText = computed(() => {
    if (!isAmountCellLayout.value) {
        return formatConversionHistoryScalar(props.value);
    }
    return formatConversionHistoryAmount(props.value);
});

watch(
    () => [isShowMenu.value, isMobile.value] as const,
    ([open, mobile]) => {
        if (typeof document === 'undefined') {
            return;
        }
        document.documentElement.style.overflow = open && mobile ? 'hidden' : '';
    },
);

onUnmounted(() => {
    if (typeof document !== 'undefined') {
        document.documentElement.style.overflow = '';
    }
});

return { __sfc: true,props, isShowMenu, $vuetify, isMobile, menuWidth, menuHeight, detailRows, isExpandable, isAmountCellLayout, plainText, BaseList, BaseListItem, SvgArrow }
}

})